import React from "react";
import s from "./s.module.scss";
import { useHistory } from "react-router-dom";
import { MenuOutlined, UserOutlined, DownOutlined } from "@ant-design/icons";
import logo from "./logoblack.png";

function Header() {
  const history = useHistory();
  return (
    <div className={s.wrap}>
      <div className={s.top}>
        <div className={s.inner}>
          <h1
            onClick={() => {
              history.push("/home");
            }}
          >
            <img src={logo} />
          </h1>
          <div className={s.topMid}>
            <span>Market</span>
            <span>Balance</span>
            <span>Community</span>
            <span>Hosting</span>
          </div>
          <div className={s.topRight}>
            <span className={s.login}>
              <span>LOGIN</span>
              <UserOutlined style={{ fontSize: 18 }} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
